import React, { useEffect, useState } from 'react';
import '../styles/StatsSection.css';

const OPEN_SOURCED_API_URL =
    'https://us-central1-chatapplication-9c954.cloudfunctions.net/getProblemsSolved';

const OpenSourcedListShimmer = ({ rows = 14 }) => (
    <table className="open-sourced-shimmer">
        <thead>
            <tr>
                <th>Company</th>
                <th>Problem Solved</th>
                <th>Date</th>
            </tr>
        </thead>
        <tbody>
            {Array.from({ length: rows }, (_, index) => (
                <tr key={index}>
                    <td><span className="shimmer-bar shimmer-bar--short" /></td>
                    <td><span className="shimmer-bar shimmer-bar--long" /></td>
                    <td><span className="shimmer-bar shimmer-bar--medium" /></td>
                </tr>
            ))}
        </tbody>
    </table>
);

const OpenSourcedList = ({ openSourced }) => {
    const handleRowClick = (url) => {
        window.open(url, '_blank'); // Opens the URL in a new tab
    };

    return (
        <table>
            <thead>
                <tr>
                    <th>Company</th>
                    <th>Problem Solved</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                {openSourced.map((item, index) => (
                    <tr 
                        key={index} 
                        onClick={() => handleRowClick(item.commitHash)}
                        style={{ cursor: 'pointer' }} // Change cursor to pointer to indicate clickability
                    >
                        <td>{item.company}</td>
                        <td>{item.problemSolved}</td>
                        <td>{item.solvedDate}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

const StatsSection = () => {
    const [openSourcedData, setOpenSourcedData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();

        fetch(OPEN_SOURCED_API_URL, { signal: controller.signal })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to load open-source contributions');
                }
                return response.json();
            })
            .then((data) => {
                setOpenSourcedData(data);
                setLoading(false);
            })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    setError(err.message);
                    setLoading(false);
                }
            });

        return () => controller.abort();
    }, []);

    return (
        <div className="stats-section">
            <h2>Open-Source Contributions</h2>
            <div className="projects-container">
                {loading && <OpenSourcedListShimmer />}
                {error && <p>{error}</p>}
                {!loading && !error && (
                    <OpenSourcedList openSourced={openSourcedData} />
                )}
            </div>
        </div>
    );
};

export default StatsSection;